<!-- 上传课件 -->
<template>
  <div v-loading="loading" class="uploadCourseware">
    <header class="header">
      <span>上传课件</span>
      <!-- <el-button type="primary">保存</el-button> -->
    </header>
    <div>
      <el-form :model="announcement" ref="announcement" label-width="150px">
        <el-form-item label="课件名称" prop="name" :rules="[{ required: true, message: '课件名称不能为空'}]">
          <el-input
            type="name"
            v-model="announcement.name"
            :maxlength="50"
            placeholder="请输入课件名称"
            style="width:480px;"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="可见授课班级"
          prop="courseIds"
          :rules="[{ required: true, message: '可见授课班级不能为空'}]"
        >
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            v-if="cities.length>0"
          >全选</el-checkbox>
          <span v-else>暂无数据</span>
          <!-- <div style="margin: 15px 0;"></div> -->
          <el-checkbox-group v-model="announcement.courseIds" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="item in cities" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="选择文件" prop="courseWareAttachmentTOS" :rules="[{ required: true, message: '选择文件不能为空'}]">
          <UpFile @onSucceed="onFileUpLoad" :maxSize="100" v-if="announcement.courseWareAttachmentTOS.length < 1"></UpFile>
          <p v-for="(item,idx) in announcement.courseWareAttachmentTOS" :key="idx" style="margin: 0;">
            {{item.name}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.size}}kb
            <i
              class="el-icon-delete delete"
              @click="delFile(item,idx)"
            ></i>
          </p>
        </el-form-item>
        <el-form-item label="备注内容" prop="remark" :rules="[{ required: true, message: '备注内容不能为空'}]">
          <!-- <rich-editor :value="announcement.remark" ref="answer"></rich-editor> -->
          <el-input
            type="textarea"
            :rows="3"
                style="width: 500px;"
            placeholder="请输入备注内容"
            v-model="announcement.remark">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('announcement')">提交</el-button>
          <el-button @click="$router.go(-1)">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import UpFile from "../common/uploadFile";
import richEditor from "@/components/common/RichEditor.vue";
export default {
  components: {
    richEditor,
    UpFile
  },
  data() {
    return {
      loading: false,
      checkAll: false,
      cities: [], // 总数据
      isIndeterminate: false,

      param: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId
      }, // 可见授课班级
      announcement: {
        courseIds: [],
        courseWareAttachmentTOS: [],
        name: "",
        remark: "",
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId
      }
    };
  },
  created() {
    this.getCourseSummaryList();
  },
  methods: {
      // 保存
    submitForm(formName) {
      // this.announcement.remark = this.$refs.answer.getContent(); // 拿到富文本的内容
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.$api.allianceSchool
            .uploadCourseWare(this.announcement)
            .then(res => {
              this.loading = false;
              if (res.errCode == 0) {
                this.$router.go(-1)
              } else {
                this.$message.error(res.errMsg);
              }
            }).catch(res=>{
            this.loading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除文件
    delFile(item,idx) {
      const than = this;
     this.$confirm("您确认删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          than.announcement.courseWareAttachmentTOS.splice(idx,1);
      });
    },
    // 上传
    onFileUpLoad(res) {
      const param = {
        name: res.file.name,
        size: (res.file.size / 1024).toFixed(2),
        url: res.item.url
      };
      this.announcement.courseWareAttachmentTOS.push(param);
    },
    // 获取可见授课班级
    getCourseSummaryList() {
      this.loading = true;
      this.$api.allianceSchool.getCourseSummaryList(this.param).then(res => {
        this.loading = false;
        if (res.errCode == 0) {
          this.cities = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      }).catch(res=>{
        this.loading = false;
      });
    },
    // 可见授课全选
    handleCheckAllChange(val) {
      if (val) {
        const param = [];
        this.cities.forEach((item, idx) => {
          param.push(item.id);
        });
        this.announcement.courseIds = param;
      } else {
        this.announcement.courseIds = [];
      }
      this.isIndeterminate = false;
    },
    // 可见授课单选
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    }
  }
};
</script>
<style lang='less' scoped>
.uploadCourseware {
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  header {
    span {
      font-size:16px;
      font-family:PingFang-SC;
      color:#424346;
    }
  }
}
.delete {
  font-size: 20px;
  color: red;
  cursor: pointer;
  padding-left: 10px;
}
</style>